import React from 'react';
import {
  DialogContentText,
  DialogTitle,
  DialogContent,
  DialogActions,
  Dialog,
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Divider,
  Grid,
  TextField,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  Radio,
  Button,
} from '@material-ui/core';

export default function FormDialog() {
  const [open, setOpen] = React.useState(false);
  const [value, setValue] = React.useState('female');

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  return (
    <div>
      <Button variant="contained" color="primary" href="/my-offers/new">
        Create a new offer now!
      </Button>
      <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">Subscribe</DialogTitle>
        <DialogContent>
          <Card

          >
            <form
              autoComplete="off"
              noValidate
            >
              <CardHeader
                subheader="The information can be edited"
                title="Offer details"
              />
              <Divider />
              <CardContent>
                <Grid
                  container
                  spacing={3}
                >
                  <Grid
                    item
                    md={6}
                    xs={12}
                  >
                    <TextField
                      fullWidth
                      helperText="Please specify the offer title"
                      label="Offer Title"
                      margin="dense"
                      name="title"
                      onChange={handleChange}
                      required

                      variant="outlined"
                    />
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={12}
                  >
                    <TextField
                      fullWidth
                      label="Position or Department."
                      margin="dense"
                      name="position"
                      onChange={handleChange}
                      required

                      variant="outlined"
                    />
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={12}
                  >
                    <TextField
                      fullWidth
                      label="Targeted Major"
                      margin="dense"
                      name="targeted_major"
                      onChange={handleChange}
                      required

                      variant="outlined"
                    />
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={12}
                  >
                    <TextField
                      fullWidth
                      label="Number of Positions"
                      margin="dense"
                      name="open_positions"
                      onChange={handleChange}
                      type="number"

                      variant="outlined"
                    />
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={12}
                  >
                    <TextField
                      fullWidth
                      label="Company"
                      margin="dense"
                      name="company"
                      onChange={handleChange}
                      type="text"
                      multiline="true"

                      variant="outlined"
                    />

                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={12}
                  >
                    <TextField
                      fullWidth
                      label="Location (Ex: Agadir, Morocco)"
                      margin="dense"
                      name="country"
                      onChange={handleChange}
                      required
                      // value={values.country}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid
                    item
                    lg={12}
                  >
                    <TextField
                      fullWidth
                      label="Offer description"
                      margin="dense"
                      name="country"
                      multiline="true"
                      onChange={handleChange}
                      required
                      // value={values.country}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item
                    lg={12}>
                  <TextField
                      id="date"
                      label="Deadline for applications"
                      type="date"
                      defaultValue="2020-05-24"
                    />
                  </Grid>
                </Grid>
              </CardContent>
              <Divider />
              <CardActions>
                <Button
                  color="primary"
                  variant="contained"
                >
                  Save details
          </Button>
              </CardActions>
            </form>
          </Card>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleClose} color="primary">
            Subscribe
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}